export default {
      id: "x-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#x-usage",
      toString: function () {
        return this.url;
      }
    }